import type { ReactNode } from 'react';

export function SubParagraphTitle(props: { children: ReactNode }) {
    return <h4>{props.children}</h4>;
}
